export const config = {
    storakAuthApiUrl: process.env.REACT_APP_STORAK_AUTH_API_URL,
    storakPlusURL: process.env.REACT_APP_STORAK_PLUS_URL,
    facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID,
    facebookGraphApiUrl: process.env.REACT_APP_FACEBOOK_GRAPH_API_URL,
    facebookGraphApiVersion : process.env.REACT_APP_FACEBOOK_GRAPH_API_VERSION
}

